import { useMemo } from 'react';
import { useUpdateEffect } from 'react-use';

import { Bean, FieldControllerProps, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { MoneyInput, StyledMaxWidth } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';
import { MedicalServiceDefaultPrice } from '../defaultPrice/defaultPrice.types';

import { MedicalServiceFixedValue } from './fixedValue.types';

type MedicalServiceFixedValueFieldProps = FieldControllerProps<
   'fixedValue',
   MedicalServiceFixedValue | null | undefined
> & {
   readonly defaultPrice: MedicalServiceDefaultPrice | null;
   readonly disabled?: boolean;
   readonly trigger: (name: 'fixedValue') => void;
};

export const MedicalServiceFixedValueField = (props: MedicalServiceFixedValueFieldProps): JSX.Element => {
   const maxValue = props.defaultPrice ?? Number.MAX_SAFE_INTEGER;

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required,
         max: {
            value: maxValue,
            message: medicalServiceTranslationKeys.shared.fixedValue.field.validate.max,
         },
      };
   }, [props.required, maxValue]);

   useUpdateEffect(() => {
      props.trigger('fixedValue');
   }, [maxValue]);

   return (
      <StyledMaxWidth maxWidth={133}>
         <MoneyInput
            testId={props.name}
            label={medicalServiceTranslationKeys.shared.fixedValue.field.label.name}
            controller={props.register(props.name, validationRules)}
            defaultValue={props.defaultValue}
            pattern={MoneyPatternType.POSITIVE}
            min={1}
            max={maxValue}
            nowrap
            disabled={props.disabled}
         />
      </StyledMaxWidth>
   );
};
